import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const FilterButton = forwardRef((props, ref) => (
  <BaseButton
    ref={ref}
    id='filter-button'
    icon='filter'
    themeColor='tertiary'
    {...props}
  />
));

export default FilterButton;